var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcess2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1449.12 1570.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-21,.cls-3,.cls-41{fill:none;}.cls-2{isolation:isolate;}.cls-3{stroke:#065299;stroke-width:4.3px;}.cls-21,.cls-27,.cls-3,.cls-31,.cls-41{stroke-miterlimit:10;}.cls-4{fill:#1e1e1d;}.cls-31,.cls-5{fill:#3c3c3b;}.cls-6{fill:#065299;}.cls-7{fill:#4380c1;}.cls-8{fill:#1967ad;}.cls-35,.cls-9{fill:#5bbfed;}.cls-10{fill:#70706f;}.cls-11{fill:#5a5a58;}.cls-12{fill:#afafaf;}.cls-13{fill:#c6c6c5;}.cls-14{fill:#838585;}.cls-15{fill:#999;}.cls-16{fill:#dcd7d0;}.cls-17{fill:#d7d8d8;}.cls-18{fill:#eaeaea;}.cls-19,.cls-33,.cls-35,.cls-36,.cls-38{mix-blend-mode:screen;}.cls-20{fill:#666;}.cls-21{stroke:#838585;stroke-width:0.74px;}.cls-22,.cls-26,.cls-27{fill:#9a9a9a;}.cls-22{mix-blend-mode:multiply;}.cls-23{fill:#fff;}.cls-24{fill:#068c38;}.cls-25{fill:#e10f1a;}.cls-27{stroke:#5a5a58;stroke-width:0.37px;}.cls-28{clip-path:url(#clip-path);}.cls-29{fill:#f4f3f3;}.cls-30{fill:#38acdd;}.cls-31{stroke:#f4f3f3;stroke-width:1.73px;}.cls-32,.cls-33{fill:#3fbee4;}.cls-34{fill:#8ecfdd;}.cls-36{fill:#84a7b7;}.cls-37,.cls-38{fill:#748f94;}.cls-39{fill:#7ab0bd;}.cls-40{fill:#586c72;}.cls-41{stroke:#17b9ec;stroke-width:2.82px;}.cls-42{font-size:44.73px;font-family:Poppins-Bold, Poppins;font-weight:700;}.cls-42,.cls-44{fill:#2170b6;}.cls-43{fill:#17b9ec;}.cls-44{font-size:36px;font-family:Montserrat-Regular, Montserrat;}.cls-45{font-family:Lato-Regular, Lato;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M908.34,1296.31h104.53a36.83,36.83,0,0,1,36.83,36.83V1543a0,0,0,0,1,0,0H871.51a0,0,0,0,1,0,0V1333.14A36.83,36.83,0,0,1,908.34,1296.31Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "128.31 219.53 331.52 219.53 331.52 50.09 1357.4 50.09 1357.4 581.27 1350.36 662.48 1343.37 698.52 1356.12 698.52 1356.12 1417.26 1395.12 1417.26 1359.52 1443.44 1359.52 1525.01 893.25 1525.01 727.74 1525.01 727.74 1326.47 444.73 1326.47 138.34 1326.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 199.13,
    y: 204.18,
    width: 29.58,
    height: 29.66
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 108.55,
    cy: 17.2,
    rx: 60.34,
    ry: 7.63
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.22 12.81 59.78 15.56 59.78 9.56 85.22 6.82 85.22 12.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "131.68 12.81 157.13 15.56 157.13 9.56 131.68 6.82 131.68 12.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 105.19,
    y: 14.4,
    width: 6.36,
    height: 4.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 105.19,
    y: 4.41,
    width: 6.36,
    height: 6.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.66,68.48l-36.4-27.54a5.49,5.49,0,0,1-2.19-4.39V18.18C167.6,21,153,24.83,153,24.83H67.42S49.5,21,48,18.18V36.55a5.51,5.51,0,0,1-2.18,4.39L9.44,68.48a20,20,0,0,0-7.93,16V244.53c0,24.28,14.85,33.56,42.93,38.3s64.11,4.42,64.11,4.42,36,.33,64.11-4.42,42.93-14,42.93-38.3V84.44A20,20,0,0,0,207.66,68.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M169.45,38.53c0-.25-.38-1.73-.38-2V18.18c-1.47,2.78-34.88,5.54-60.6,5.54S49.5,21,48,18.18V36.55a5.33,5.33,0,0,1-.18,1.38c8.94,4.61,28.16,5.7,61.51,5.7,0,0,23.47-.16,44.5-1.09C161.28,42.21,164.94,41.38,169.45,38.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M139.51,91.79c-12.39.83-24.4,1.25-34.32,1.24C26.76,92.16,7.54,80.86,2.24,79.12a20.09,20.09,0,0,0-.73,5.32V244.53c0,24.28,14.85,33.56,42.93,38.3s64.11,4.42,64.11,4.42,13.79.12,31-.9a322.11,322.11,0,0,0,33.15-3.52c4.44-.75,8.54-1.61,12.31-2.63V86.7A456.21,456.21,0,0,1,139.51,91.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M215.59,244.53V84.44a20,20,0,0,0-1.53-7.68c-3,4-14.3,7.37-29.09,9.94V280.2C205.06,274.78,215.59,265,215.59,244.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M16.33,84.72V275.26c6.66,3.48,15.16,5.83,25.46,7.57,2.37.4,4.81.77,7.27,1.1V90.23A233.09,233.09,0,0,1,16.33,84.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M465.26,110h0l-.05-14.31c0-11.63-9.81-14.82-22-14.9-12.46,0-22.62,3.07-22.56,14.9l0,14.31h0V280h44.64V110Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "465.21 279.86 420.67 279.86 424.93 287.26 460.95 287.26 465.21 279.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M451.46,81.33a1.91,1.91,0,0,1-1.9,1.91H436.32a1.91,1.91,0,0,1-1.9-1.91h0a1.91,1.91,0,0,1,1.9-1.91h13.24a1.91,1.91,0,0,1,1.9,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M446.41,81.54h4.91c.66-.91-.46-2.12-1-2.12h-3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M465.24,110l-.05-14.31c0-11.63-10.36-14.19-17.55-14.71-1.05-.08-.22-.23-1.23-.19,6.81.71,13.1,4.12,13.07,14.9l0,14.31h0V280h5.71V110Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "426.42 88.34 455.33 88.34 450.61 83.24 431.01 83.24 426.42 88.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "436.32 79.92 442.3 79.92 441.93 81.33 435.46 81.33 436.32 79.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "454.3 80.05 431.58 80.05 428.52 74.44 457.36 74.44 454.3 80.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M459.33,74.72a59.67,59.67,0,0,1-32.78,0c-7-11-10.33-26.17-5.78-40.36,9.22-8.45,35.12-8.45,44.34,0C469.66,48.55,466.3,63.67,459.33,74.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M429.2,72.69l-2.65,2a59.67,59.67,0,0,0,32.78,0l-2.65-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M461.52,41.83l3.59-7.47c-9.22-8.45-35.12-8.45-44.34,0l3.59,7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M456.68,72.69a54.66,54.66,0,0,1-27.48,0c-5.83-8.45-4.84-19.84-4.84-30.86,7.62-2,29.66-2.24,37.16,0C461.52,53.29,462.51,64.24,456.68,72.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 425.56,
    y: 46.11,
    width: 34.77,
    height: 13.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 440.49,
    y: 47.77,
    width: 18.12,
    height: 9.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 449.08,
    cy: 67.93,
    rx: 3.65,
    ry: 3.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 438.08,
    cy: 67.84,
    rx: 1.94,
    ry: 1.87
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 441.93,
    cy: 67.93,
    rx: 1.07,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 434.17,
    cy: 67.93,
    rx: 1.07,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 420.67,
    y: 264.9,
    width: 44.44,
    height: 22.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 426.42,
    y: 92.46,
    width: 8,
    height: 172.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 426.42,
    y: 264.9,
    width: 8,
    height: 14.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M630.74,109.53h0l-.06-14.31c0-11.63-9.8-14.83-22-14.9-12.45,0-22.61,3.07-22.55,14.9l0,14.31h0V279.47h44.64V109.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "630.68 279.35 586.15 279.35 590.41 286.74 626.42 286.74 630.68 279.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M616.94,80.82A1.92,1.92,0,0,1,615,82.73H601.8a1.91,1.91,0,0,1-1.9-1.91h0a1.9,1.9,0,0,1,1.9-1.91H615a1.91,1.91,0,0,1,1.91,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M611.89,81h4.9c.66-.92-.45-2.12-.95-2.12h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M630.72,109.53l-.06-14.31c0-11.63-10.35-14.19-17.55-14.72-1-.07-.21-.23-1.22-.18C618.7,81,625,84.44,625,95.22l0,14.31h0V279.47h5.71V109.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "591.9 87.83 620.8 87.83 616.09 82.73 596.49 82.73 591.9 87.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "601.79 79.41 607.78 79.41 607.41 80.82 600.94 80.82 601.79 79.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "619.77 79.54 597.06 79.54 593.99 73.93 622.84 73.93 619.77 79.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M624.81,74.21a59.71,59.71,0,0,1-32.79,0c-7-11-10.32-26.17-5.78-40.36,9.22-8.46,35.13-8.46,44.35,0C635.13,48,631.77,63.16,624.81,74.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M594.68,72.18l-2.66,2a59.71,59.71,0,0,0,32.79,0l-2.66-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M627,41.32l3.59-7.47c-9.22-8.46-35.13-8.46-44.35,0l3.6,7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M622.15,72.18a54.62,54.62,0,0,1-27.47,0c-5.84-8.45-4.84-19.85-4.84-30.86,7.61-2,29.66-2.24,37.16,0C627,52.77,628,63.73,622.15,72.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 591.03,
    y: 45.6,
    width: 34.77,
    height: 13.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 605.97,
    y: 47.25,
    width: 18.12,
    height: 9.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 614.55,
    cy: 67.42,
    rx: 3.65,
    ry: 3.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 603.56,
    cy: 67.33,
    rx: 1.94,
    ry: 1.87
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 607.4,
    cy: 67.42,
    rx: 1.07,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 599.65,
    cy: 67.42,
    rx: 1.07,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 586.15,
    y: 264.39,
    width: 44.44,
    height: 22.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 591.9,
    y: 91.95,
    width: 8,
    height: 172.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 591.9,
    y: 264.39,
    width: 8,
    height: 14.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M784.86,110h0l-.06-14.31c0-11.63-9.8-14.82-22-14.9-12.45,0-22.61,3.07-22.55,14.9l0,14.31h0V280h44.63V110Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "784.81 279.86 740.28 279.86 744.54 287.26 780.55 287.26 784.81 279.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M771.06,81.33a1.91,1.91,0,0,1-1.9,1.91H755.93a1.91,1.91,0,0,1-1.9-1.91h0a1.91,1.91,0,0,1,1.9-1.91h13.23a1.91,1.91,0,0,1,1.9,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M766,81.54h4.9c.66-.91-.45-2.12-.95-2.12h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M784.85,110l-.06-14.31c0-11.63-10.35-14.19-17.55-14.71-1-.08-.21-.23-1.22-.19,6.8.71,13.1,4.12,13.06,14.9l.06,14.31h0V280h5.7V110Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "746.03 88.34 774.93 88.34 770.22 83.24 750.62 83.24 746.03 88.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "755.92 79.92 761.91 79.92 761.53 81.33 755.07 81.33 755.92 79.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "773.9 80.05 751.19 80.05 748.12 74.44 776.97 74.44 773.9 80.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M778.94,74.72a59.71,59.71,0,0,1-32.79,0c-7-11-10.32-26.17-5.78-40.36,9.22-8.45,35.13-8.45,44.35,0C789.26,48.55,785.9,63.67,778.94,74.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M748.81,72.69l-2.66,2a59.71,59.71,0,0,0,32.79,0l-2.66-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M781.13,41.83l3.59-7.47c-9.22-8.45-35.13-8.45-44.35,0l3.6,7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M776.28,72.69a54.62,54.62,0,0,1-27.47,0C743,64.24,744,52.85,744,41.83c7.61-2,29.66-2.24,37.16,0C781.13,53.29,782.12,64.24,776.28,72.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 745.16,
    y: 46.11,
    width: 34.77,
    height: 13.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 760.1,
    y: 47.77,
    width: 18.12,
    height: 9.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 768.68,
    cy: 67.93,
    rx: 3.65,
    ry: 3.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 757.69,
    cy: 67.84,
    rx: 1.94,
    ry: 1.87
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 761.53,
    cy: 67.93,
    rx: 1.07,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 753.78,
    cy: 67.93,
    rx: 1.07,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 740.28,
    y: 264.9,
    width: 44.44,
    height: 22.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 746.03,
    y: 92.46,
    width: 8,
    height: 172.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 746.03,
    y: 264.9,
    width: 8,
    height: 14.96
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "788.81 278.99 790.68 287.26 857.75 287.26 859.64 278.99 788.81 278.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "788.81 278.99 859.64 278.99 857.75 287.26 790.68 287.26 788.81 278.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M859.83,198V186H788.47v6h-.32v84.42h71.17V276h.51v-7.83h-.51v-2.31l.51-.25v-4.84l-.51.31v-11.6l.15-.16.36-.37v-7.25l-.51.31V230.4l.15-.15.36-.37v-7.25l-.51.3v-11.6l.15-.15.36-.37v-5.48c-.18.17-.34.34-.51.51V198Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 787.12,
    y: 176.41,
    width: 73.89,
    height: 13.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 787.83,
    y: 185.25,
    width: 71.81,
    height: 1.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 798.03,
    y: 190.84,
    width: 22.76,
    height: 85.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 786.79,
    y: 274.86,
    width: 73.89,
    height: 4.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 787.83,
    y: 275.75,
    width: 71.81,
    height: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 853.74,
    y: 190.84,
    width: 6.08,
    height: 85.18
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "789 190.08 859.83 190.08 859.83 193.09 789 191.59 789 190.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M920.73,58.14h38.53a0,0,0,0,1,0,0V123.5A11.31,11.31,0,0,1,948,134.81H932a11.31,11.31,0,0,1-11.31-11.31V58.14A0,0,0,0,1,920.73,58.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M968.27,42.88V56.37a2.2,2.2,0,0,1,0,.36,2.75,2.75,0,0,1-2.71,1.41h-51a2.74,2.74,0,0,1-2.71-1.41,1.49,1.49,0,0,1,0-.36V42.88a1.49,1.49,0,0,1,0-.36,2.78,2.78,0,0,1,2.71-1.42h52A1.78,1.78,0,0,1,968.27,42.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M968.27,54v2.36a2.2,2.2,0,0,1,0,.36,2.75,2.75,0,0,1-2.71,1.41h-51a2.74,2.74,0,0,1-2.71-1.41,1.49,1.49,0,0,1,0-.36V42.88a1.49,1.49,0,0,1,0-.36,2.78,2.78,0,0,1,2.71-1.42h4.25V52.24c0,1,1.23,1.77,2.75,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M928,114.71a1.92,1.92,0,0,1-1.92-1.93V73.14a1.93,1.93,0,1,1,3.85,0v39.64A1.92,1.92,0,0,1,928,114.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M940,114.71a1.92,1.92,0,0,1-1.92-1.93V73.14a1.93,1.93,0,1,1,3.85,0v39.64A1.92,1.92,0,0,1,940,114.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M952,114.71a1.92,1.92,0,0,1-1.93-1.93V73.14a1.93,1.93,0,1,1,3.85,0v39.64A1.92,1.92,0,0,1,952,114.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M527.05,1336.27h38.53a0,0,0,0,1,0,0v65.36a11.31,11.31,0,0,1-11.31,11.31H538.36a11.31,11.31,0,0,1-11.31-11.31v-65.36A0,0,0,0,1,527.05,1336.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M574.59,1321v13.49a2.2,2.2,0,0,1,0,.36,2.75,2.75,0,0,1-2.71,1.41h-51a2.75,2.75,0,0,1-2.71-1.41,2.23,2.23,0,0,1-.05-.36V1321a2.23,2.23,0,0,1,.05-.36,2.79,2.79,0,0,1,2.71-1.42h52A1.78,1.78,0,0,1,574.59,1321Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M574.59,1332.14v2.36a2.2,2.2,0,0,1,0,.36,2.75,2.75,0,0,1-2.71,1.41h-51a2.75,2.75,0,0,1-2.71-1.41,2.23,2.23,0,0,1-.05-.36V1321a2.23,2.23,0,0,1,.05-.36,2.79,2.79,0,0,1,2.71-1.42h4.25v11.14c0,1,1.23,1.77,2.76,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M534.31,1392.84a1.92,1.92,0,0,1-1.93-1.93v-39.64a1.93,1.93,0,1,1,3.85,0v39.64A1.92,1.92,0,0,1,534.31,1392.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M546.32,1392.84a1.92,1.92,0,0,1-1.93-1.93v-39.64a1.93,1.93,0,1,1,3.85,0v39.64A1.92,1.92,0,0,1,546.32,1392.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M558.33,1392.84a1.92,1.92,0,0,1-1.92-1.93v-39.64a1.92,1.92,0,1,1,3.84,0v39.64A1.92,1.92,0,0,1,558.33,1392.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1110.23,
    y: 253.41,
    width: 5.23,
    height: 14.42
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1115.46 267.36 1111.93 267.36 1111.93 253.41 1110.23 253.41 1110.23 267.83 1115.46 267.83 1115.46 267.36"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1114.55,
    y: 253.41,
    width: 0.91,
    height: 14.42
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1140.97,
    y: 253.41,
    width: 5.23,
    height: 14.42
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1146.21 267.36 1142.68 267.36 1142.68 253.41 1140.97 253.41 1140.97 267.83 1146.21 267.83 1146.21 267.36"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1145.29,
    y: 253.41,
    width: 0.91,
    height: 14.42
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1110.23,
    y: 264.48,
    width: 75.3,
    height: 5.25
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1185.06 264.48 1185.06 268.02 1110.23 268.02 1110.23 269.73 1185.53 269.73 1185.53 264.48 1185.06 264.48"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1110.23,
    y: 264.48,
    width: 75.3,
    height: 0.92
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1184.17,
    y: 262.27,
    width: 2.54,
    height: 9.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1185.64,
    y: 260.24,
    width: 3.65,
    height: 13.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1193.79,
    y: 264.48,
    width: 14.22,
    height: 5.25
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1194.26 269.73 1194.26 266.19 1208.01 266.19 1208.01 264.48 1193.79 264.48 1193.79 269.73 1194.26 269.73"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1193.79,
    y: 268.81,
    width: 14.22,
    height: 0.92
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1192.61,
    y: 262.27,
    width: 2.54,
    height: 9.66,
    transform: "translate(2387.77 534.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1190.03,
    y: 260.24,
    width: 3.65,
    height: 13.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1122.69,190.87h0l0-59c0-4.58-4.33-5.84-9.7-5.86s-10,1.2-10,5.86v59h0v66.89h19.69V190.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1116.6,126.19a.79.79,0,0,1-.84.75h-5.84a.79.79,0,0,1-.83-.75h0a.79.79,0,0,1,.83-.75h5.84a.8.8,0,0,1,.84.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1114.37,126.28h2.17c.29-.37-.2-.84-.42-.84h-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1122.68,190.87l0-59c0-4.58-4.57-5.58-7.75-5.79-.46,0-.09-.09-.54-.07,3,.28,5.78,1.62,5.77,5.86l0,59h0v66.89h2.52V190.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1105.56 128.95 1118.31 128.95 1116.23 126.94 1107.58 126.94 1105.56 128.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1109.92 125.64 1112.56 125.64 1112.4 126.19 1109.55 126.19 1109.92 125.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 1105.56,
    y: 130.57,
    width: 3.53,
    height: 121.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1122.66 257.71 1103.02 257.71 1104.9 260.63 1120.79 260.63 1122.66 257.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1103.02,
    y: 251.83,
    width: 19.6,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1105.56,
    y: 251.83,
    width: 3.53,
    height: 5.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1153.45,190.87h0l0-59c0-4.58-4.32-5.84-9.69-5.86s-10,1.2-10,5.86v59h0v66.89h19.68V190.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1147.37,126.19a.8.8,0,0,1-.84.75h-5.84a.8.8,0,0,1-.84-.75h0a.8.8,0,0,1,.84-.75h5.84a.8.8,0,0,1,.84.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1145.14,126.28h2.17c.29-.37-.21-.84-.43-.84h-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1153.45,190.87l0-59c0-4.58-4.56-5.58-7.74-5.79-.46,0-.09-.09-.54-.07,3,.28,5.78,1.62,5.77,5.86l0,59h0v66.89h2.51V190.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1136.33 128.95 1149.07 128.95 1146.99 126.94 1138.35 126.94 1136.33 128.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1140.69 125.64 1143.33 125.64 1143.16 126.19 1140.31 126.19 1140.69 125.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 1136.32,
    y: 130.57,
    width: 3.53,
    height: 121.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1153.43 257.71 1133.79 257.71 1135.67 260.63 1151.55 260.63 1153.43 257.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1133.79,
    y: 251.83,
    width: 19.6,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1136.32,
    y: 251.83,
    width: 3.53,
    height: 5.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 1082.42,
    y: 4.48,
    width: 87.63,
    height: 139.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1170.05,
    y: 6.22,
    width: 87.63,
    height: 137.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1229.56,215.57h0l0-5c0-4.07-6.08-5.18-13.62-5.21-7.72,0-14,1.07-14,5.21l0,5h0V275h27.66V215.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1229.53 274.96 1201.93 274.96 1204.57 277.54 1226.89 277.54 1229.53 274.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1221,205.53c0,.37-.53.67-1.18.67h-8.2c-.65,0-1.18-.3-1.18-.67h0c0-.36.53-.66,1.18-.66h8.2c.65,0,1.18.3,1.18.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1217.88,205.61h3c.41-.32-.28-.74-.59-.74h-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1229.55,215.57l0-5c0-4.07-6.42-5-10.88-5.15-.64,0-.13-.08-.76-.06,4.22.25,8.12,1.44,8.1,5.21l0,5h0V275h3.53V215.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1205.49 207.99 1223.41 207.99 1220.49 206.2 1208.34 206.2 1205.49 207.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1211.63 205.04 1215.34 205.04 1215.11 205.53 1211.1 205.53 1211.63 205.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1201.93,
    y: 269.73,
    width: 27.54,
    height: 7.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 1205.49,
    y: 209.43,
    width: 4.96,
    height: 60.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1205.49,
    y: 269.73,
    width: 4.96,
    height: 5.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1201.38,152.68h27.92a0,0,0,0,1,0,0v42.38a8.19,8.19,0,0,1-8.19,8.19h-11.53a8.19,8.19,0,0,1-8.19-8.19V152.68a0,0,0,0,1,0,0Z",
    transform: "translate(2430.67 355.92) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1194.85,214.3v-9.77a2.3,2.3,0,0,1,0-.26,2,2,0,0,1,2-1h37a2,2,0,0,1,2,1,2.3,2.3,0,0,1,0,.26v9.77a2.3,2.3,0,0,1,0,.26,2,2,0,0,1-2,1h-37.7A1.29,1.29,0,0,1,1194.85,214.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1194.85,206.23v-1.7a2.3,2.3,0,0,1,0-.26,2,2,0,0,1,2-1h37a2,2,0,0,1,2,1,2.3,2.3,0,0,1,0,.26v9.77a2.3,2.3,0,0,1,0,.26,2,2,0,0,1-2,1h-3.09v-8.07c0-.72-.89-1.29-2-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1224,167.24a1.39,1.39,0,0,1,1.39,1.39v23.75a1.39,1.39,0,0,1-2.78,0V168.63A1.39,1.39,0,0,1,1224,167.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1215.34,167.24a1.39,1.39,0,0,1,1.39,1.39v23.75a1.4,1.4,0,0,1-2.79,0V168.63A1.39,1.39,0,0,1,1215.34,167.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1206.64,167.24a1.39,1.39,0,0,1,1.39,1.39v23.75a1.4,1.4,0,0,1-2.79,0V168.63A1.4,1.4,0,0,1,1206.64,167.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1076.58,0V288h186.94V0Zm176.51,277.54H1087V10.45h166.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1164.53,
    y: 8.81,
    width: 11.03,
    height: 139.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1082.42,
    y: 138.47,
    width: 175.25,
    height: 11.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1104,
    y: 24.86,
    width: 12.66,
    height: 76.75,
    rx: 6.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1110.33,
    y1: 32.74,
    x2: 1110.33,
    y2: 93.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1106.76,
    y1: 32.74,
    x2: 1113.91,
    y2: 32.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1106.76,
    y1: 41.45,
    x2: 1113.91,
    y2: 41.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1106.76,
    y1: 50.17,
    x2: 1113.91,
    y2: 50.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1106.76,
    y1: 58.88,
    x2: 1113.91,
    y2: 58.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1106.76,
    y1: 67.59,
    x2: 1113.91,
    y2: 67.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1106.76,
    y1: 76.3,
    x2: 1113.91,
    y2: 76.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1106.76,
    y1: 85.01,
    x2: 1113.91,
    y2: 85.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1106.76,
    y1: 93.72,
    x2: 1113.91,
    y2: 93.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1135.81,
    y: 24.86,
    width: 12.66,
    height: 76.75,
    rx: 6.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1142.14,
    y1: 32.74,
    x2: 1142.14,
    y2: 93.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1138.56,
    y1: 32.74,
    x2: 1145.72,
    y2: 32.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1138.56,
    y1: 41.45,
    x2: 1145.72,
    y2: 41.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1138.56,
    y1: 50.17,
    x2: 1145.72,
    y2: 50.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1138.56,
    y1: 58.88,
    x2: 1145.72,
    y2: 58.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1138.56,
    y1: 67.59,
    x2: 1145.72,
    y2: 67.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1138.56,
    y1: 76.3,
    x2: 1145.72,
    y2: 76.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1138.56,
    y1: 85.01,
    x2: 1145.72,
    y2: 85.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1138.56,
    y1: 93.72,
    x2: 1145.72,
    y2: 93.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1114.06,118.19a10.44,10.44,0,1,1-10.44-10.46A10.45,10.45,0,0,1,1114.06,118.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1112.84,118.19a9.18,9.18,0,1,1-9.18-9.21A9.2,9.2,0,0,1,1112.84,118.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1111.8,118.19a8.18,8.18,0,1,1-8.18-8.2A8.19,8.19,0,0,1,1111.8,118.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1103.63,118.15h6.82a6.84,6.84,0,0,0-6.82-6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1159.28,118.19a10.44,10.44,0,1,1-10.43-10.46A10.44,10.44,0,0,1,1159.28,118.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1158.07,118.19a9.19,9.19,0,1,1-9.18-9.21A9.2,9.2,0,0,1,1158.07,118.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1157,118.19a8.18,8.18,0,1,1-8.18-8.2A8.19,8.19,0,0,1,1157,118.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1148.85,118.15h6.83a6.84,6.84,0,0,0-6.83-6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1136.67,118.19a10.44,10.44,0,1,1-10.43-10.46A10.44,10.44,0,0,1,1136.67,118.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1135.46,118.19a9.19,9.19,0,1,1-9.19-9.21A9.2,9.2,0,0,1,1135.46,118.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1134.41,118.19a8.18,8.18,0,1,1-8.17-8.2A8.19,8.19,0,0,1,1134.41,118.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1126.24,118.15h6.83a6.85,6.85,0,0,0-6.83-6.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1184.32,
    y: 24.86,
    width: 25.54,
    height: 15.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1186.41,
    y: 26.95,
    width: 21.37,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1190.93,
    y: 29.98,
    width: 12.32,
    height: 5.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1217.86,
    y: 24.86,
    width: 25.54,
    height: 15.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1219.95,
    y: 26.95,
    width: 21.37,
    height: 11.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1224.47,
    y: 29.98,
    width: 12.32,
    height: 5.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1194.6,
    cy: 95.34,
    rx: 7.5,
    ry: 7.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 1194.6,
    cy: 95.34,
    rx: 6.18,
    ry: 6.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1233.12,
    cy: 95.34,
    rx: 7.5,
    ry: 7.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 1233.12,
    cy: 95.34,
    rx: 6.18,
    ry: 6.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1213.86,
    cy: 95.34,
    rx: 7.5,
    ry: 7.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 1213.86,
    cy: 95.34,
    rx: 6.18,
    ry: 6.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1190.93,
    y: 61.47,
    width: 10.99,
    height: 20.33,
    transform: "translate(2392.86 143.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1191.22,
    y: 61.89,
    width: 10.42,
    height: 19.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1191.22,
    y: 61.89,
    width: 10.42,
    height: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1191.22,
    y: 76.66,
    width: 10.42,
    height: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1196.78,
    y: 113.4,
    width: 15.21,
    height: 15.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1204.39,
    cy: 120.48,
    rx: 6.11,
    ry: 6.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1203.37,
    y: 123.77,
    width: 2.05,
    height: 3.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1224.83,
    cy: 120.48,
    rx: 6.11,
    ry: 6.13
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1220.84 117.06 1221.41 116.48 1224.18 119.25 1223.6 119.83 1220.84 117.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1076.58,
    y: 287.99,
    width: 186.94,
    height: 20.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1385.55,509.58H1206.06c-32.36,10.63-61.15,21.6-61.15,27V740.85c0,12.35,17.7,22.37,39.54,22.37h223.83c21.84,0,39.54-10,39.54-22.37V536.6C1447.82,531.18,1418.5,520.21,1385.55,509.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1331.21,501.88h45.59a7.91,7.91,0,0,1,7.91,7.91v2.74a0,0,0,0,1,0,0h-61.4a0,0,0,0,1,0,0v-2.74A7.91,7.91,0,0,1,1331.21,501.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1167.32 541.7 1167.32 749.86 1206.63 749.86 1206.63 530.19 1167.32 541.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1381.52 530.19 1381.52 749.86 1420.83 749.86 1420.83 541.7 1381.52 530.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1143.61,
    y: 557.48,
    width: 305.51,
    height: 6.83,
    transform: "translate(2592.73 1121.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1143.61,
    y: 592.74,
    width: 305.51,
    height: 6.83,
    transform: "translate(2592.73 1192.3) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1143.61,
    y: 628,
    width: 305.51,
    height: 6.83,
    transform: "translate(2592.73 1262.82) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1143.61,
    y: 663.26,
    width: 305.51,
    height: 6.83,
    transform: "translate(2592.73 1333.34) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1143.61,
    y: 698.52,
    width: 305.51,
    height: 6.83,
    transform: "translate(2592.73 1403.86) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M908.34,1296.31h104.53a36.83,36.83,0,0,1,36.83,36.83V1543a0,0,0,0,1,0,0H871.51a0,0,0,0,1,0,0V1333.14A36.83,36.83,0,0,1,908.34,1296.31Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 996.41,
    cy: 1425.74,
    rx: 11.01,
    ry: 11.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 996.41,
    cy: 1425.74,
    rx: 9.07,
    ry: 9.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 924.8,
    cy: 1425.74,
    rx: 11.01,
    ry: 11.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 924.8,
    cy: 1425.74,
    rx: 9.07,
    ry: 9.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 871.51,
    y: 1349.67,
    width: 178.19,
    height: 11.41
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 861.94,
    y: 1315.36,
    width: 198.75,
    height: 10.98
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 950.65,
    y: 1414.7,
    width: 20.16,
    height: 38.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 955.84,
    y: 1414.7,
    width: 9.79,
    height: 38.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 955.84,
    y: 1445.61,
    width: 9.79,
    height: 7.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 924.8,
    cy: 1498.06,
    rx: 15.2,
    ry: 15.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 924.8,
    cy: 1498.06,
    rx: 6.77,
    ry: 6.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M924.81,1511.35h0l-.73,0,.13-2.45.6,0Zm4.38-.75-.82-2.31.57-.22.94,2.27Zm-9.45-.25-.68-.31,1.06-2.21.55.25Zm13.89-2.39-1.63-1.82a5.77,5.77,0,0,0,.44-.42l1.73,1.73A6.51,6.51,0,0,1,933.63,1508Zm-18.19-.49q-.27-.27-.51-.54l1.82-1.64q.19.23.42.45Zm21.3-3.64-2.2-1.07c.08-.18.17-.37.24-.55l2.26.93C937,1503.38,936.85,1503.6,936.74,1503.83Zm-24.18-.66c-.1-.23-.18-.46-.27-.7l2.31-.81c.07.19.14.38.22.57ZM938,1498.8l-2.44-.13c0-.2,0-.4,0-.61l1.85,0h.6C938.05,1498.31,938,1498.56,938,1498.8Zm-26.49-.71v0c0-.24,0-.48,0-.71l2.44.13c0,.19,0,.39,0,.58Zm23.45-3.65c-.07-.19-.14-.38-.22-.56l2.25-1c.1.23.19.46.27.7Zm-20.19-.5-2.26-.94c.09-.23.19-.46.3-.68l2.21,1.06C915,1493.56,914.88,1493.75,914.8,1493.94Zm18-3.13-.42-.44,1.72-1.74q.27.27.51.54Zm-15.7-.39-1.73-1.73q.27-.27.54-.51l1.64,1.82Zm12.32-2.14-.55-.25.93-2.27.68.31Zm-8.82-.22-.94-2.26.69-.27.82,2.31Zm4.74-.82-.57,0,0-2.45h.11c.16,0,.39,0,.63,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 996.41,
    cy: 1498.06,
    rx: 15.2,
    ry: 15.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 978.38,
    y: 1494.61,
    width: 36.07,
    height: 6.91,
    rx: 3.45,
    transform: "translate(2494.47 501.65) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 995.4,
    y: 1491.61,
    width: 2.03,
    height: 12.91,
    transform: "translate(1992.83 2996.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1049.7,
    y: 1519.07,
    width: 10.52,
    height: 10.55
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "114.16 1380.62 119.85 1411.52 103.08 1411.52 108.77 1380.62 114.16 1380.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "107.36 1410.98 112.95 1380.62 108.77 1380.62 103.08 1411.52 119.85 1411.52 119.75 1410.98 107.36 1410.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M121.94,1422.2v-21H100.49v20.69c-14.87,7-40.68,19.81-40.68,24.62V1558c0,6.74,6,12.21,13.42,12.21h76c7.41,0,13.42-5.47,13.42-12.21v-111.5C162.62,1441.74,137.18,1429.26,121.94,1422.2ZM160.16,1558c0,5.5-4.92,10-11,10h-76c-6,0-11-4.48-11-10v-111.5c.13-.39,2.44-5.28,39.36-22.64a2.21,2.21,0,0,0,1.33-2v-18.31h16.54v18.66a2.23,2.23,0,0,0,1.34,2c36.85,17.06,39.21,21.9,39.36,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M120.82,1424.19a2.23,2.23,0,0,1-1.34-2v-18.66H102.94v18.31a2.21,2.21,0,0,1-1.33,2c-36.92,17.36-39.23,22.25-39.36,22.64V1558c0,5.5,4.92,10,11,10h76c6.05,0,11-4.48,11-10l0-111.39C160,1446.09,157.67,1441.25,120.82,1424.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M120.82,1424.19a2.23,2.23,0,0,1-1.34-2v-21H102.94v20.69a2.21,2.21,0,0,1-1.33,2c-36.92,17.36-39.23,22.25-39.36,22.64V1558c0,5.5,4.92,10,11,10h76c6.05,0,11-4.48,11-10l0-111.39C160,1446.09,157.67,1441.25,120.82,1424.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M95.1,1533.8a1.34,1.34,0,1,1,1.46-1.34A1.4,1.4,0,0,1,95.1,1533.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M116.85,1518a1.34,1.34,0,1,1,1.46-1.34A1.41,1.41,0,0,1,116.85,1518Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M106.93,1472.4a1.2,1.2,0,1,1,0-2.39,1.28,1.28,0,0,1,1.32,1.2A1.26,1.26,0,0,1,106.93,1472.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M72.23,1531.13a1.2,1.2,0,1,1,1.31-1.19A1.26,1.26,0,0,1,72.23,1531.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M70.09,1555a1.2,1.2,0,1,1,1.31-1.2A1.25,1.25,0,0,1,70.09,1555Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M92.14,1466.38a2.22,2.22,0,1,1,2.43-2.22A2.34,2.34,0,0,1,92.14,1466.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M103,1563.52a2.29,2.29,0,1,1,2.5-2.28A2.4,2.4,0,0,1,103,1563.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M99.33,1550a1.14,1.14,0,0,1-1.19-1.08,1.19,1.19,0,0,1,2.37,0A1.14,1.14,0,0,1,99.33,1550Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M115.38,1485a1.08,1.08,0,1,1,1.18-1.08A1.12,1.12,0,0,1,115.38,1485Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M111.94,1542.65a2,2,0,1,1,2.17-2A2.09,2.09,0,0,1,111.94,1542.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M74.4,1482.87a2,2,0,1,1,2.17-2A2.09,2.09,0,0,1,74.4,1482.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M82.54,1449.85a2,2,0,1,1,2.22-2A2.14,2.14,0,0,1,82.54,1449.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M80.11,1545.79a2.24,2.24,0,1,1,2.45-2.24A2.36,2.36,0,0,1,80.11,1545.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M125,1472.05a1.34,1.34,0,1,1-1.46,1.33A1.4,1.4,0,0,1,125,1472.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M103.27,1487.88a1.34,1.34,0,1,1-1.46,1.34A1.4,1.4,0,0,1,103.27,1487.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M113.19,1533.44a1.2,1.2,0,1,1,0,2.4,1.21,1.21,0,1,1,0-2.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 147.9,
    cy: 1475.91,
    rx: 1.31,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M150,1450.83a1.2,1.2,0,1,1,0,2.39,1.2,1.2,0,1,1,0-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M128,1539.47a2.22,2.22,0,1,1-2.43,2.22A2.33,2.33,0,0,1,128,1539.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M117.1,1442.33a2.29,2.29,0,1,1-2.5,2.28A2.4,2.4,0,0,1,117.1,1442.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M120.79,1455.87A1.13,1.13,0,0,1,122,1457a1.19,1.19,0,0,1-2.37,0A1.14,1.14,0,0,1,120.79,1455.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M104.74,1520.82a1.08,1.08,0,1,1-1.18,1.08A1.13,1.13,0,0,1,104.74,1520.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M108.18,1463.2a2,2,0,1,1-2.17,2A2.09,2.09,0,0,1,108.18,1463.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M145.72,1523a2,2,0,1,1-2.17,2A2.09,2.09,0,0,1,145.72,1523Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M137.58,1556a2,2,0,1,1-2.22,2A2.14,2.14,0,0,1,137.58,1556Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M140,1460.06a2.24,2.24,0,1,1-2.45,2.24A2.36,2.36,0,0,1,140,1460.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 56.07,
    y: 1519.31,
    width: 110.29,
    height: 13.94,
    transform: "translate(222.43 3052.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 56.58,
    y: 1494.68,
    width: 110.29,
    height: 13.94,
    transform: "translate(223.45 3003.3) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 56.58,
    y: 1469.6,
    width: 110.29,
    height: 13.94,
    transform: "translate(223.45 2953.13) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "271.45 1380.62 277.14 1411.52 260.37 1411.52 266.06 1380.62 271.45 1380.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "264.64 1410.98 270.23 1380.62 266.06 1380.62 260.37 1411.52 277.14 1411.52 277.04 1410.98 264.64 1410.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M279.22,1422.2v-21H257.78v20.69c-14.88,7-40.69,19.81-40.69,24.62V1558c0,6.74,6,12.21,13.42,12.21h76c7.41,0,13.42-5.47,13.42-12.21v-111.5C319.91,1441.74,294.47,1429.26,279.22,1422.2ZM317.45,1558c0,5.5-4.92,10-11,10h-76c-6,0-11-4.48-11-10v-111.5c.13-.39,2.44-5.28,39.35-22.64a2.2,2.2,0,0,0,1.33-2v-18.31h16.54v18.66a2.23,2.23,0,0,0,1.34,2c36.86,17.06,39.21,21.9,39.36,22.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M278.1,1424.19a2.23,2.23,0,0,1-1.34-2v-18.66H260.22v18.31a2.2,2.2,0,0,1-1.33,2c-36.91,17.36-39.22,22.25-39.35,22.64V1558c0,5.5,4.92,10,11,10h76c6,0,11-4.48,11-10V1446.58C317.31,1446.09,315,1441.25,278.1,1424.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M278.1,1424.19a2.23,2.23,0,0,1-1.34-2v-21H260.22v20.69a2.2,2.2,0,0,1-1.33,2c-36.91,17.36-39.22,22.25-39.35,22.64V1558c0,5.5,4.92,10,11,10h76c6,0,11-4.48,11-10V1446.58C317.31,1446.09,315,1441.25,278.1,1424.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M252.38,1533.8a1.34,1.34,0,1,1,1.47-1.34A1.41,1.41,0,0,1,252.38,1533.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M274.13,1518a1.34,1.34,0,1,1,1.46-1.34A1.4,1.4,0,0,1,274.13,1518Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M264.22,1472.4a1.2,1.2,0,1,1,0-2.39,1.2,1.2,0,1,1,0,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M229.51,1531.13a1.2,1.2,0,1,1,1.31-1.19A1.25,1.25,0,0,1,229.51,1531.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M227.38,1555a1.2,1.2,0,1,1,1.31-1.2A1.26,1.26,0,0,1,227.38,1555Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M249.43,1466.38a2.22,2.22,0,1,1,2.43-2.22A2.35,2.35,0,0,1,249.43,1466.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M260.3,1563.52a2.29,2.29,0,1,1,2.5-2.28A2.39,2.39,0,0,1,260.3,1563.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M256.61,1550a1.09,1.09,0,1,1,1.19-1.09A1.14,1.14,0,0,1,256.61,1550Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M272.66,1485a1.09,1.09,0,1,1,0-2.16,1.09,1.09,0,1,1,0,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M269.23,1542.65a2,2,0,1,1,2.17-2A2.08,2.08,0,0,1,269.23,1542.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M231.69,1482.87a2,2,0,1,1,2.17-2A2.08,2.08,0,0,1,231.69,1482.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M239.83,1449.85a2,2,0,1,1,2.22-2A2.13,2.13,0,0,1,239.83,1449.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M237.39,1545.79a2.25,2.25,0,1,1,2.46-2.24A2.35,2.35,0,0,1,237.39,1545.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M282.31,1472.05a1.4,1.4,0,0,1,1.47,1.33,1.48,1.48,0,1,1-1.47-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M260.56,1487.88a1.34,1.34,0,1,1-1.46,1.34A1.4,1.4,0,0,1,260.56,1487.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M270.47,1533.44a1.21,1.21,0,1,1-1.31,1.2A1.27,1.27,0,0,1,270.47,1533.44Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 305.18,
    cy: 1475.91,
    rx: 1.31,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M307.31,1450.83A1.2,1.2,0,1,1,306,1452,1.26,1.26,0,0,1,307.31,1450.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M285.26,1539.47a2.22,2.22,0,1,1-2.43,2.22A2.34,2.34,0,0,1,285.26,1539.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M274.39,1442.33a2.29,2.29,0,1,1-2.5,2.28A2.39,2.39,0,0,1,274.39,1442.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M278.08,1455.87a1.09,1.09,0,1,1-1.19,1.09A1.13,1.13,0,0,1,278.08,1455.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M262,1520.82a1.09,1.09,0,1,1,0,2.16,1.09,1.09,0,1,1,0-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M265.46,1463.2a2,2,0,1,1-2.17,2A2.08,2.08,0,0,1,265.46,1463.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M303,1523a2,2,0,1,1-2.17,2A2.08,2.08,0,0,1,303,1523Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M294.86,1556a2,2,0,1,1-2.22,2A2.13,2.13,0,0,1,294.86,1556Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M297.3,1460.06a2.25,2.25,0,1,1-2.46,2.24A2.35,2.35,0,0,1,297.3,1460.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 213.35,
    y: 1519.31,
    width: 110.29,
    height: 13.94,
    transform: "translate(537 3052.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 213.86,
    y: 1494.68,
    width: 110.29,
    height: 13.94,
    transform: "translate(538.02 3003.3) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 213.86,
    y: 1469.6,
    width: 110.29,
    height: 13.94,
    transform: "translate(538.02 2953.13) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M145.6,1353.21a12.73,12.73,0,0,0-4.71.9H103.08a7.5,7.5,0,0,1,7.5-7.51h68.55v7.51H150.31A12.73,12.73,0,0,0,145.6,1353.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M140.89,1354.11a12.77,12.77,0,0,1,9.42,0h28.82v10.5H121.05v23.32h-18v-33.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M110.58,1346.6h68.55v7.51h-76A7.5,7.5,0,0,1,110.58,1346.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 159.97,
    y: 1328.6,
    width: 19.16,
    height: 36.64,
    transform: "translate(339.1 2693.84) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M178,1324H161.12v-9.24a2.77,2.77,0,0,1,2.76-2.77h11.34a2.76,2.76,0,0,1,2.76,2.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M175.67,1322.33H163.43V1316a2.4,2.4,0,0,1,2.4-2.4h7.44a2.39,2.39,0,0,1,2.4,2.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 164.59,
    y: 1314.43,
    width: 4.96,
    height: 3.53
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M219.85,1324H203v-9.24a2.77,2.77,0,0,1,2.77-2.77h11.33a2.77,2.77,0,0,1,2.77,2.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M217.53,1322.33H205.29V1316a2.4,2.4,0,0,1,2.4-2.4h7.44a2.39,2.39,0,0,1,2.4,2.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 206.45,
    y: 1314.43,
    width: 4.96,
    height: 3.53
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 58.73,
    y: 1323.44,
    width: 261.1,
    height: 6.01
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 58.73,
    y: 1324.8,
    width: 261.1,
    height: 3.29
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M235.36,1354.05a12.9,12.9,0,0,1,4.71.9h37.81a7.5,7.5,0,0,0-7.49-7.51H201.83V1355h28.82A13,13,0,0,1,235.36,1354.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M240.07,1355a12.77,12.77,0,0,0-9.42,0H201.83v10.5h58.08v23.33h18V1355Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M270.39,1347.44H201.83V1355h76A7.5,7.5,0,0,0,270.39,1347.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 201.83,
    y: 1329.45,
    width: 19.16,
    height: 36.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1321.32,
    y: 1456.32,
    width: 75.03,
    height: 37.74,
    transform: "translate(2717.68 2950.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1369.61,
    y: 1456.32,
    width: 13.51,
    height: 25.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1344.52,
    y: 1456.32,
    width: 5.3,
    height: 25.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1159.69,1456.43v0l-20.93-.08c-17,0-21.68-14.38-21.79-32.25,0-18.28,4.5-33.19,21.79-33.1l20.93,0h248.52v65.5H1159.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1159.7,1456.4l-20.92-.08c-17,0-20.75-15.19-21.52-25.75-.12-1.53,0-.28-.15-1.86,1.05,10,5.89,19.28,21.67,19.24l20.92.08v0h248.51v8.38H1159.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1134.53,
    y: 1399.44,
    width: 273.5,
    height: 11.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1134.53,
    y: 1432.32,
    width: 273.5,
    height: 4.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1128.51,1396.63v46.81s-9-5.4-9-20.86C1119.52,1402,1128.51,1396.63,1128.51,1396.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1178.7,
    y: 1373.57,
    width: 20.55,
    height: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1195.86,
    y: 1373.57,
    width: 1.86,
    height: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1188.98,
    y: 1373.57,
    width: 2.9,
    height: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1178.92,
    y: 1373.57,
    width: 1.27,
    height: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1184.63,
    y: 1373.57,
    width: 1.73,
    height: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1347.12,
    y: 1373.57,
    width: 20.55,
    height: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1364.28,
    y: 1373.57,
    width: 1.86,
    height: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1357.39,
    y: 1373.57,
    width: 2.9,
    height: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1347.33,
    y: 1373.57,
    width: 1.27,
    height: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1353.04,
    y: 1373.57,
    width: 1.73,
    height: 17.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1408.03,
    y: 1394.98,
    width: 15.18,
    height: 55.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 1.41,
    y: 381.75,
    width: 1059.18,
    height: 856.85,
    rx: 33.82
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-42",
    transform: "translate(71.15 484.72)"
  }, "BENEFICIOS DE UNA PLANTA DE AGUA"), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "18.61 448.41 9.35 459.1 0.09 469.8 0.09 448.41 0.09 427.02 9.35 437.71 18.61 448.41"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-44",
    transform: "translate(67.09 566.16)"
  }, "\u25B6", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 0,
    xmlSpace: "preserve"
  }, "   Versatilidad y eficiencia."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 49.2
  }, "\u25B6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 49.2,
    xmlSpace: "preserve"
  }, "   Inversion altamente rentable."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 98.4
  }, "\u25B6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 98.4,
    xmlSpace: "preserve"
  }, "   Excelente calidad de agua producto."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 147.6
  }, "\u25B6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 147.6,
    xmlSpace: "preserve"
  }, "   Te damos la calidad de agua que tu deseas."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 196.8
  }, "\u25B6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 196.8,
    xmlSpace: "preserve"
  }, "   Justo al tama\xF1o de tu presupuesto."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 246
  }, "\u25B6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 246,
    xmlSpace: "preserve"
  }, "   Excelente oportunidad de negocio."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 295.2
  }, "\u25B6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 295.2,
    xmlSpace: "preserve"
  }, "   Resultados medibles."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 344.4
  }, "\u25B6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 344.4,
    xmlSpace: "preserve"
  }, "   Automatizable y facil de manejar."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 393.6
  }, "\u25B6 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 31.03,
    y: 393.6,
    xmlSpace: "preserve"
  }, " Manual de control operacional."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 442.8
  }, "\u25B6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 442.8,
    xmlSpace: "preserve"
  }, "   Manual de sanitizaci\xF3n de todo el sistema."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 492
  }, "\u25B6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 492,
    xmlSpace: "preserve"
  }, "   Con sistemas de seguridad."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 541.2
  }, "\u25B6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 541.2,
    xmlSpace: "preserve"
  }, "   Asesoria y respaldo tecnico permanente."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 590.4
  }, "\u25B6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 21.6,
    y: 590.4,
    xmlSpace: "preserve"
  }, "   Nuestra experiencia nos respalda.")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess2);
export default __webpack_public_path__ + "static/media/process2.bbfd5dbb482d9c5ef26aea71ddd80ceb.svg";
export { ForwardRef as ReactComponent };